/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

interface EnableModalArgs {
  readOnly: boolean;
  enableSubscriptionCenter: () => unknown;
  onClose: () => unknown;
  animateTopicTable: () => unknown;
}

export default class EnableModalComponent extends Component<EnableModalArgs> {
  @tracked showConfirmationModal = false;

  cheerImage = new URL('cio/assets/images/cheer.png', import.meta.url).toString();

  @action
  enableSubscriptionCenter() {
    this.args.enableSubscriptionCenter();
    this.showConfirmationModal = true;
  }

  @action
  animateAndCloseModal() {
    this.args.onClose();
    this.args.animateTopicTable();
  }
}
